import React from "react";
import { useSelector } from "react-redux";

import styles from "./GiftSelector.module.scss";
import { SaleItemInterface } from "../../../common/types/interfaces";
import { selectClusterList } from "../../../store/slices/clusterListSlice";
import {
  getClusterImageUrl,
  getFirstImage,
} from "../../../common/utils/functions/getImageUri";

interface Props {
  giftItems: SaleItemInterface[];
  selectedGiftId?: number;
  clusterId: number;
  onSelect: (itemId: number) => void;
}

export const GiftSelector: React.FC<Props> = ({
  giftItems,
  selectedGiftId,
  clusterId,
  onSelect,
}) => {
  const clusters = useSelector(selectClusterList);
  const cluster = clusters.find((c) => Number(c.id) === Number(clusterId));

  if (giftItems.length === 0) return null;

  const isSelected = selectedGiftId !== undefined && selectedGiftId !== null;

  return (
    <div className={styles.Container}>
      <div className={`${styles.Header} ${!isSelected ? styles.Required : ""}`}>
        {isSelected
          ? "Подарок выбран"
          : "Выберите подарок (обязательно)"}
      </div>

      <div className={styles.Grid}>
        {giftItems.map((item) => {
          const isActive = selectedGiftId === item.id;
          const image = getFirstImage(item.files);

          return (
            <button
              key={item.id}
              type="button"
              className={`${styles.Card} ${isActive ? styles.Active : ""}`}
              onClick={() => onSelect(item.id)}
            >
              {image && cluster ? (
                <img
                  className={styles.Image}
                  src={getClusterImageUrl(cluster, image)}
                  alt={item.name}
                  loading="lazy"
                />
              ) : (
                <div className={styles.ImagePlaceholder} />
              )}
              <span className={styles.Name}>{item.name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};